<template>
  <div>
    <div class="ListingGrid-loading text-primary flex justify-center" v-show="isPending">
      <i class="fal fa-spinner-third fa-spin"></i>
    </div>

    <div class="text-center mt-24 text-sm" v-if="!isPending && postsData?.posts?.length === 0">
      Sorry the artist does not have any posts yet.
    </div>

    <div class="ListingGrid mt-12">
      <ArtistStudioPost v-for="post in postsData?.posts || []" :post="post" :key="post.id" />
    </div>

    <PaginationWithDefaults v-model="currentPage" :page-count="pageCount" />
  </div>
</template>

<script setup>
import PaginationWithDefaults from "@/components/PaginationWIthDefaults.vue"
import Http from "@/lib/Http"
import ArtistStudioPost from "@/pages/ArtistProfilePage/ArtistStudioPost.vue"
import { useQuery } from "@tanstack/vue-query"
import { computed, inject, onMounted, onUnmounted, ref } from "vue"

const page = ref(1)

const artist = inject("artist")
const scrollToTabs = inject("scrollToTabs")

const queryKey = computed(() => `studioPosts${artist.id}${page.value}`)

const { data: postsData, isPending } = useQuery({
  queryKey: [queryKey],
  queryFn: async () =>
    (
      await Http.get(`/api/artists/${artist.id}/studio_posts`, {
        params: { per: 5, page: page.value },
      })
    ).data,
  refetchOnWindowFocus: false,
})

const currentPage = computed({
  set(newPage) {
    page.value = newPage
    window.history.pushState({ page: page.value, turbo: {} }, "", `${window.location.pathname}?page=${page.value}`)
    scrollToTabs()
  },
  get() {
    return page.value
  },
})

const pageCount = computed(() => {
  return Math.ceil(postsData.value?.posts_count / 5)
})

onMounted(() => {
  const handlePopState = (event) => {
    page.value = event.state.page || 1
  }

  window.addEventListener("popstate", handlePopState)

  onUnmounted(() => {
    window.removeEventListener("popstate", handlePopState)
  })
})
</script>
